import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import AsyncSelect from 'react-select/lib/Async';

// for customStyling examples
// check here https://react-select.com/styles
// documentation: https://react-select.com/home#async

export class AutoComplete extends Component {
  static propTypes = {
    async: PropTypes.bool,
    isMulti: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    isMulti: true, // this handle multi selected
    // styles: {
    //   container: (styles, state) => ({
    //     ...styles,
    //     // border: '1px solid black',
    //     borderRadius: '0px',
    //   }),
    //   control: (styles, state) => ({
    //     ...styles,
    //     borderRadius: '0px',
    //     borderBottomWidth: '1px',
    //     borderWidth: 'none',
    //     borderColor: 'inherit',
    //     boxShadow: state.isFocused ? 0 : 0,
    //     padding: '5px 0',
    //     isFocused: 'disabled',
    //     '&:hover': {
    //       cursor: 'pointer',
    //       borderWidth: 'none',
    //     },
    //   }),
    //   menu: (styles, state) => ({
    //     ...styles,
    //     // border: '1px solid black',
    //     borderRadius: '0px',
    //   }),
    //   indicatorSeparator: provided => ({
    //     ...provided,
    //     backgroundColor: 'transparent',
    //   }),
    //   menuList: (styles, state) => ({
    //     ...styles,
    //     borderRadius: '0px',
    //     '&:hover': {
    //       cursor: 'pointer',
    //     },
    //   }),
    //   valueContainer: (styles, state) => ({
    //     ...styles,
    //     padding: '0px',
    //   }),
    //   menuPortal: (styles, state) => ({
    //     ...styles,
    //     // border: '1px solid black',
    //     backgroundColor: 'palegoldenrod',
    //   }),

    //   multiValue: (styles, state) => ({
    //     ...styles,
    //     backgroundColor: 'whiteSmoke',
    //     borderRadius: '24px',
    //     padding: '4px 10px',
    //   }),
    //   multiValueRemove: (styles, state) => ({
    //     ...styles,
    //     backgroundColor: 'whiteSmoke',
    //     color: 'gray',
    //     '&:hover': {
    //       backgroundColor: 'whiteSmoke',
    //       color: 'black',
    //       cursor: 'pointer',
    //     },
    //   }),
    //   option: (styles, state) => ({
    //     ...styles,
    //     border: '0px',
    //     '&:hover': {
    //       cursor: 'pointer',
    //     },
    //   }),
    // },
  };

  render() {
    const { async, disabled, ...passThrough } = this.props;

    if (async) {
      return <AsyncSelect isDisabled={disabled} {...passThrough} />;
    }

    return <Select isDisabled={disabled} {...passThrough} />;
  }
}

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/ui/common/multi-auto-complete/index.js